export default {
  data() {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
      isMiddleScreen: false,
    };
  },
  async mounted() {
    this.checkViewport();
  },
  methods: {
    checkViewport() {
      const app = this;
      if (window.innerWidth <= 767) { /* MOBILE */
        app.isMobile = true;
        app.isTablet = false;
        app.isDesktop = false;
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1279 ) { /* TABLET */
        app.isMobile = false;
        app.isTablet = true;
        app.isDesktop = false;
      } else if (window.innerWidth >= 1280) { /* DESKTOP */
        app.isMobile = false;
        app.isTablet = false;
        app.isMiddleScreen = false;
        app.isDesktop = true;
      }
      window.addEventListener("resize", function () { /* MOBILE */
        if (window.innerWidth <= 767) {
          app.isMobile = true;
          app.isTablet = false;
          app.isMiddleScreen = false;
          app.isDesktop = false;
        } else if (window.innerWidth >= 768 && window.innerWidth <= 1279) { /* TABLET */
          app.isMobile = false;
          app.isTablet = true;
          app.isMiddleScreen = false;
          app.isDesktop = false;
        } else if (window.innerWidth >= 1280) { /* DESKTOP */
          app.isMobile = false;
          app.isTablet = false;
          app.isMiddleScreen = false;
          app.isDesktop = true;
        }
      });
    },
  },
};
